import { render } from "./FrontendMobileCategoryComponent.vue?vue&type=template&id=327378c2"
import script from "./FrontendMobileCategoryComponent.vue?vue&type=script&lang=js"
export * from "./FrontendMobileCategoryComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/layouts/frontend/FrontendMobileCategoryComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "327378c2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('327378c2', __exports__)) {
    api.reload('327378c2', __exports__)
  }
  
  module.hot.accept("./FrontendMobileCategoryComponent.vue?vue&type=template&id=327378c2", () => {
    api.rerender('327378c2', render)
  })

}


export default __exports__